import locationsService from '../services/locationsService.js';
import dataModel from '../models/DataModel';
import DAO from './DAO.js';
import StoreItemProcessing from '../helpers/StoreFunctions/StoreItemProcessing';
import ReduxConstants, { RecordStates } from '../constants/ReduxConstants.js';

export const location_root = {
  location: {
    market: {},
    location_users: { user: { additionalFields: ['profile_image'] } },
    users: {},
    projects: {},
  },
};

export default class LocationsDAO extends DAO {

  constructor(store) {
    super(store, 'location');

    this.unsetLocation = this.unsetLocation.bind(this);
    this.clearLocations = this.clearLocations.bind(this);
    this.checkLocationsCollections = this.checkLocationsCollections.bind(this);
    this.deleteLocation = this.deleteLocation.bind(this);
    this.getLocation = this.getLocation.bind(this);
  }

  unsetLocation(id) {
    StoreItemProcessing.deleteItemInStore(this.itemType, id);
  }

  clearLocations() {
    StoreItemProcessing.clearItemsInStore(this.itemType);
  }

  getLocation(locationId, options) {
    return this._getItem(locationId, locationsService.getLocation.bind(this, locationId, options), options);
  }

  findLocationsCounts(user_id) {
    let locations = [];
    for (const project of Object.values(this.stateTree.new_projects)) {
      if (project && project.is_favorite) {
        if (locations.indexOf(project.location_id) < 0) {
          locations.push(project.location_id);
        }
      }
    }
    return { active_locations_count: locations.length, locations_count: locations.length };
  }

  getLocationsCountFromStore(user_id, options) {
    let locations = [];
    for (const project of Object.values(this.stateTree.new_projects)) {
      if (project) {
        if (locations.indexOf(project.location_id) < 0) {
          locations.push(project.location_id);
        }
      }
    }
    return { active_locations_count: locations.length, locations_count: locations.length };
  }

  getLocationsCount(user_id, options) {
    if (dataModel.isOffline) {
      const results = this.findLocationsCounts(user_id);
      return new Promise(resolve => {
        this.markSynced(results);
        resolve(results);
      });
    }
    return locationsService.getMyLocationsCount({ id: user_id }).then((results) => {
      if (results.error) {
        dataModel.displayHTTPError('Updating locations count', results.error, false);
        results = { active_locations_count: 0, locations_count: 0 };
        for (const location of Object.values(this.stateTree.new_locations)) {
          // TODO: determine active locations
          if (location){
            results.active_locations_count++;
            results.locations_count++;
          }
        }
      }
      return results;
    });
  }

  clearState(options) {
    this.clearMyState(this.stateTree.new_locations, options.toIgnore.locations, this.unsetLocation, this.clearLocations, options);
  }

  handleResponse(location, response, dontQueue, options, errorMessage) {
    if (response.offline && dontQueue) {
      return response;    
    }
    else if (response.offline) {
      this.throwItemError();
    }
    else if (response.error) {
      const error = response.error.response && response.error.response.data && response.error.response.data.name ? 'Location with same name already exist' : response.error;
      dataModel.displayHTTPError(errorMessage, error, false);
      this.markError(location);
      this.throwItemError();
    }
    else {
      this.normalizeAndSyncToStore(response, options);
      const denormalized = this.mapToReturn(this.findItem(response.data.id), options);
      return denormalized;
    }
  }

  createLocation(location, options) {
    return locationsService.createLocation(location, null, options).then(response => {
      return this.handleResponse(location, response, false, options, 'Creating a location');
    });
  }

  updateLocation(location, options) {
    if (location.market){
      location.market_id = location.market.id;
    }
    return locationsService.updateLocation(location, null, options).then(response => {
      return this.handleResponse(location, response, false, options, 'Updating a location');
    });
  }

  deleteLocation(location_id) {
    const location = this.findItem(location_id);
    if (location) {
      this.markDeleted(location);
    }
    return locationsService.deleteLocation(location_id).then(response => {
      return response;
    });
  }

  createLocationUser(locationUser) {
    return locationsService.createLocationUser(locationUser).then(response => {
      const locationUser = this.normalizeAndSyncToStore(response);
      const options = {
        recordDescriptor: {
          location_user: {
            user: {},
          },
        } };
      return this.mapToReturn(locationUser, options);
    });
  }

  updateLocationUser(locationUser) {
    return locationsService.updateLocationUser(locationUser).then(response => {
      const locationUser = this.normalizeAndSyncToStore(response);
      const options = {
        recordDescriptor: {
          location_user: {
            user: {},
          },
        } };
      return this.mapToReturn(locationUser, options);
    });
  }

  deleteLocationUser(userId, locationId) {
    return locationsService.deleteLocationUser(locationId, userId).then(response => {
      
    });
  }

  checkLocationsCollections(location_id) {
    let collectionIds = dataModel.collectionsDAO.getCollectionsByType(ReduxConstants.LOCATION);
    for (let collectionId of collectionIds) {
      let collection = dataModel.collectionsDAO.findCollection(collectionId);

      if (collection && !collection.ids.find(id => {return id == location_id;})){
        collection._recordState = RecordStates.NEEDS_SYNC;
        dataModel.collectionsDAO.setCollection(collectionId, collection, ReduxConstants.LOCATION);
      }
    }
  }

  handleActionCableAndGetRequest(acData) {    
    let location = this.findItem(acData.location_id);
    if (location) {
      if (acData.is_attribute_update) {
        this.markNeedsAttributeSync(location);
      }
      else {
        this.markNeedsSync(location);
      }
    }
    this.checkLocationsCollections(acData.location_id);
    switch (acData.type) {
    case 'newLocation':
      return this.getLocation;
    case 'updateLocation':
      return this.getLocation.bind(this);
    case 'deleteLocation':
      this.unsetLocation(acData.location_id);
      return location;
    default:
    }

  }

}



// WEBPACK FOOTER //
// ./src/dao/LocationsDAO.js